import { useState, useContext } from 'react'
import { toast } from '@/components/ui/sonner'
import { R } from '@/modules/api/actions'
import config from '@/config'
import { AuthContext } from '@/modules/auth/authContext'

export function useSlackConnect() {
    const [isLoading, setIsLoading] = useState(false)
    const { client } = useContext(AuthContext)

    const connect = async () => {
        try {
            if (!client?.name) {
                toast.error(
                    'Client information not found. Please try again later.',
                )
                return
            }

            // Skip actual API call in non-production environments if configured
            if (
                !config('IS_PRODUCTION') &&
                !process.env.NEXT_PUBLIC_ENABLE_SLACK_IN_DEV
            ) {
                toast.info('Slack integration is disabled in development mode')
                return
            }

            setIsLoading(true)

            // Make the API call using the authenticated request method
            // The backend will automatically generate the channel name based on the client from the URL
            const response = await R.getSlackChannelInvite()

            // Check if the response indicates an error
            if (response.isError) {
                throw new Error(
                    response.message || 'Failed to create Slack channel',
                )
            }

            window.open(response.result.shareLink, '_blank')
            toast.success('Opening Slack channel invite...')
        } catch (error) {
            toast.error('Failed to generate Slack invite. Please try again.')
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    return {
        connect,
        isLoading,
        isDisabled: !client,
    }
}
